import React from "react";
import { Helmet } from "react-helmet";

import { VideoShowcase } from "../components/common/VideoShowcase/VideoShowcase";

const StreetRap = () => {
  const videos = [
    "https://www.youtube.com/embed/EtAClhq7ThU?si=814ELbrf66RnUmZ9",
    "https://www.youtube.com/embed/6Vc_cbw7Wak?si=z-rGvny6sH351nOG",
    "https://www.youtube.com/embed/b8vANIh3HZg?si=drPj4hvDB-SEG77P",
    "https://www.youtube.com/embed/0EtNLFY77Ho?si=udpYh3HHQC7RPHhO",
    "https://www.youtube.com/embed/jMRCgvI5u4U?si=1qx_K5hoYLq9Ni-E",
    "https://www.youtube.com/embed/2O9726JR1tw?si=BfLRskB1ALfyJ-YB",
    "https://www.youtube.com/embed/xc5h0CVSg2A?si=y3Qf52_uzM9Oc7lv",
    "https://www.youtube.com/embed/dQS3YfbBJK0?si=zGEeQxxFe-ZQkW1R",
    "https://www.youtube.com/embed/l1om1nwB6O4?si=EbKsUO26YCM1vxX-",
  ];

  return (
    <>
      <Helmet>
        <title>
          Street Rap | راب الشوارع — Lembawe9
        </title>

        <meta
          name="description"
          content="Discover Street Rap | راب الشوارع by Lembawe9, the Moroccan rap format built around talent, authenticity and street culture."
        />
      </Helmet>

      <main>
        <VideoShowcase
          sectionNumber="STREET RAP"
          eyebrow="THE ORIGINAL FORMAT"
          title="RAP ESH-SHOUARI."
          accentTitle="راب الشوارع"
          description="A pioneering concept that helped discover and elevate Moroccan rap talent. Street Rap puts artists, authenticity and street culture at the center of every episode."
          videos={videos}
        />
      </main>
    </>
  );
};

export default StreetRap;